import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/index.scss'
import 'ant-design-vue/dist/reset.css'
import Antd from 'ant-design-vue'
import cupI18n from 'cupshe-i18n'
import CupsheRoot from '@cupshe/cupshe-root'
import microApp from '@micro-zoe/micro-app'

import component from './components/index.js'
import { installDirective } from 'utils/directive.js'
import 'cupshe-css'
import './assets/xspreadsheet.js'
import './assets/xspreadsheet.css'
import 'virtual:windi.css'
const app = createApp(App)
installDirective(app)

const supportMobile =
  `${location.href}`.includes('LibraryManagement') ||
  `${location.href}`.includes('LibraryManagementDetail')

if (supportMobile) {
  document.documentElement.style.setProperty('--body-min-width', '1200px')
}

microApp.start({
  iframe: true
})

// 设置共享域名
// document.domain = 'kapeixi.cn'
app
  .use(cupI18n, {
    domain: process.env.VUE_APP_PORTAL,
    systemId: process.env.VUE_APP_systemId,
    env: process.env.VUE_APP_MODE
  })
  .use(CupsheRoot, {
    domain: process.env.VUE_APP_PORTAL,
    systemId: process.env.VUE_APP_systemId,
    env: process.env.VUE_APP_MODE
  })
  .use(component)
  .use(Antd)
  .use(store)
  .use(router)
  .mount('#portal-app')

// start()
